import React, { useState, useEffect } from 'react'
import DropdownField from 'core/components/validatedForm/DropdownField'
import Dropdown from 'core/elements/dropdown'
import TextField from 'core/components/validatedForm/TextField'
import FormFieldSection from 'core/components/validatedForm/FormFieldSection'
import { ipamTypes } from './AddNetworkAttachmentDefinitionsModal'
import DhcpNote from './DhcpNote'
import WhereaboutsFields from './WhereaboutsFields'

export default function OvsDpdkParamFields({ params, updateParams, method = 'add' }) {
  useEffect(() => {
    if (method === 'edit') {
      return
    }

    updateParams({
      config: {
        ...params?.config,
        type: 'userspace',
        host: {
          engine: 'ovs-dpdk',
          iftype: 'vhostuser',
          netType: 'bridge',
          vhost: {
            mode: 'client',
          },
        },
        container: {
          engine: 'ovs-dpdk',
          iftype: 'vhostuser',
          netType: 'interface',
          vhost: {
            mode: 'server',
          },
        },
      },
    })
  }, [])

  return (
    <>
      <FormFieldSection title="Interface" step={method === 'edit' ? 1 : 2}>
        <TextField
          id="networkName"
          label="Network Name"
          info="The name of the network"
          value={params?.config?.name}
          onChange={(value) => updateParams({ config: { ...params?.config, name: value } })}
        />
        <TextField
          id="bridge"
          label="Bridge"
          value={params?.config?.host?.bridge?.bridgeName}
          onChange={(value) =>
            updateParams({
              config: {
                ...params?.config,
                host: {
                  ...params?.config?.host,
                  bridge: { ...params?.config?.host?.bridge, bridgeName: value },
                },
              },
            })
          }
          required
        />
        <TextField
          id="vlan"
          label="VLAN"
          type="number"
          value={params?.config?.host?.bridge?.vlanId}
          onChange={(value) =>
            updateParams({
              config: {
                ...params?.config,
                host: {
                  ...params?.config?.host,
                  bridge: { ...params?.config?.host?.bridge, vlanId: value },
                },
              },
            })
          }
        />
        <TextField
          id="resourceName"
          label="Resource Name"
          value={params?.resourceName}
          onChange={(value) => updateParams({ resourceName: value })}
        />
        <TextField
          id="logFile"
          label="Log File"
          info="File path for multus log (e.g. /var/log/multus.log)"
          value={params?.config?.logFile}
          onChange={(value) => updateParams({ config: { ...params?.config, logFile: value } })}
        />
        <TextField
          id="logLevel"
          label="Log Level"
          info="Logging level (e.g. 'debug', 'error', 'verbose' or 'panic')"
          value={params?.config?.logLevel}
          onChange={(value) => updateParams({ config: { ...params?.config, logLevel: value } })}
        />
      </FormFieldSection>
      <FormFieldSection title="IPAM (optional)" step={method === 'edit' ? 2 : 3}>
        <DropdownField
          DropdownComponent={Dropdown}
          id="ipamType"
          label="Type"
          value={params?.config?.ipam?.type}
          onChange={(value) =>
            updateParams({
              config: { ...params?.config, ipam: { ...params?.config?.ipam, type: value } },
            })
          }
          items={ipamTypes}
        />

        {params?.config?.ipam?.type === 'whereabouts' && (
          <WhereaboutsFields params={params} updateParams={updateParams} />
        )}

        {params?.config?.ipam?.type === 'dhcp' && <DhcpNote />}
      </FormFieldSection>
    </>
  )
}
